import * as React from 'react';
import { FC } from 'react';
import { NavLink } from 'react-bootstrap';
import type { YoAuthUser, YoProject, YoProjectToolMap } from '@yakoffice/yakoffice-firebase';
import { useParams } from 'react-router-dom';
import styles from '../../../../navigation-rail/src/lib/navigation-rail.module.sass';
import { compareProjectIdWithRouteParamProjectId, getToolUrl } from '@yakoffice/helpers';

enum YoGameEnvironmentRoles {
    ViewPlayers = 'ViewPlayers',
    EditPlayers = 'EditPlayers',
    CopyPlayers = 'CopyPlayers',
    ServicePlayers = 'ServicePlayers'
}


export interface YoToolMenuProps {
    authUser: YoAuthUser;
    toolId: string;
    isDevSite: boolean;
    projects: YoProject[];
}

export const YoToolMenu: FC<YoToolMenuProps> = (props) => {

    const routeParams = useParams<{ projectId: string, gameEnvironmentId: string }>();

    const toolIcon = (toolId: string) => {
        switch (toolId.toLocaleLowerCase()) {
            case 'players':
                return <i className="fas fa-users" />;
            case 'publisher':
                return <i className="fas fa-upload" />;
            case 'builds':
                return <i className="fas fa-tools" />;
            case 'sessions':
                return <i className="fas fa-globe-americas" />;
        }
    };

    function navigateToUpdatedTool(toolId: string, toolProjectId: string) {
        window.location.href = `${getToolUrl(toolId, toolProjectId, props.isDevSite, props.authUser?.getFirstAuthorisedGameEnvironmentId(toolProjectId, toolId))}`;
    }

    const isLinkActive = (tool: YoProjectToolMap) => {

        if (props.toolId.toLocaleLowerCase() !== 'players')
            return props.toolId === tool.toolId.toLocaleLowerCase();

        else if (props.toolId.toLocaleLowerCase() === 'players' && tool.toolId.toLocaleLowerCase() === 'players')
            return !window.location.pathname.includes('deletion-request');

        else
            return false;
    };

    const deletionRequestsTab = (tool: YoProjectToolMap) => {

        const navigateToPlayerDeletions = () => {
            window.location.href = `${getToolUrl('deletionRequests', tool.toolProjectId, props.isDevSite, props.authUser?.getFirstAuthorisedGameEnvironmentId(tool.toolProjectId, tool.toolId))}`;
        };

        if (routeParams.projectId !== undefined && routeParams.gameEnvironmentId && (props.authUser?.hasGameEnvironmentRoleClaim(routeParams.projectId, routeParams.gameEnvironmentId, YoGameEnvironmentRoles.EditPlayers) || props.authUser?.hasGameEnvironmentRoleClaim(routeParams.projectId, routeParams.gameEnvironmentId, YoGameEnvironmentRoles.ServicePlayers)))
            return <NavLink key={'deletionRequests'} as="a"
                            className={`${styles.navigationRailNavItem} ${styles.hiddenOnCollapsed} text-capitalize`}
                            onClick={() => navigateToPlayerDeletions()}
                            active={window.location.pathname.includes('deletion-request')}><i
                className="fas fa-user-slash" /><span>Player Deletion</span>
            </NavLink>;
    };

    if (props.authUser && props.authUser.yoUser) {

        return props.projects.map(project => {

            if (compareProjectIdWithRouteParamProjectId(project.id, routeParams.projectId)) {

                return project.tools.filter(tool => tool.toolId !== 'publisher').sort((a, b) => a.toolId.localeCompare(b.toolId)).map(tool => {

                    if (props.authUser.isAuthorisedForTool(project.id, tool.toolId))
                        return (
                            <div key={tool.toolId}>
                                <NavLink key={tool.toolId} as="a"
                                         className={`${styles.navigationRailNavItem} text-capitalize`}
                                         onClick={() => navigateToUpdatedTool(tool.toolId, tool.toolProjectId)}
                                         active={isLinkActive(tool)}>{toolIcon(tool.toolId)}<span>{tool.toolId}</span>
                                </NavLink>
                                {tool.toolId.toLowerCase() === 'players' &&
                                    deletionRequestsTab(tool)
                                }
                            </div>
                        );

                });
            } else
                return null;
        });
    } else

        return null;
};
